'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Book(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 64 : _ref$size,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? null : _ref$icon;

  return _react2.default.createElement(
    'div',
    { style: { width: size, height: size + 13 }, className: 'jsx-3383499909' + ' ' + 'holder'
    },
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-3383499909' + ' ' + 'icon'
      },
      icon
    ),
    _react2.default.createElement(
      'svg',
      {
        width: size,
        height: size + 13,
        viewBox: '0 0 40 53',
        version: '1.1',
        xmlnsXlink: 'http://www.w3.org/1999/xlink',
        className: 'jsx-3383499909'
      },
      _react2.default.createElement(
        'g',
        {
          transform: 'translate(-8.000000, -3.000000)',
          stroke: 'none',
          strokeWidth: 1,
          fill: 'none',
          fillRule: 'evenodd',
          className: 'jsx-3383499909'
        },
        _react2.default.createElement('path', {
          d: 'M48 47.41c-.091 3.139-2.807 5.615-6.072 5.535H13.757C10.577 52.945 8 50.467 8 47.41V16.485c0-3.057 2.577-5.536 5.757-5.536h28.17c3.266-.08 5.982 2.396 6.073 5.536V47.41z',
          fill: '#49497F',
          fillRule: 'nonzero',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M45.998 45.223c.08 2.95-2.38 5.405-5.495 5.482H14.018a4.392 4.392 0 0 1-3.011-1.234 3.937 3.937 0 0 1-1.202-2.893V13.232a3.937 3.937 0 0 1 1.202-2.893 4.392 4.392 0 0 1 3.011-1.234h26.485c3.115.077 5.575 2.531 5.495 5.482v30.636z',
          fill: '#F6F6F6',
          fillRule: 'nonzero',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement(
          'g',
          { transform: 'translate(14.000000, 3.000000)', fillRule: 'nonzero', className: 'jsx-3383499909'
          },
          _react2.default.createElement('polygon', {
            fill: '#F06361',
            points: '12 2.29175165 12 53 8.20909208 51.3072828 4.42321857 53 4.3828125 2.29175165',
            className: 'jsx-3383499909'
          }),
          _react2.default.createElement('path', {
            d: 'M2.593 0h7.64L12 2.292H.867S.852 0 2.593 0z',
            fill: '#C64757',
            className: 'jsx-3383499909'
          }),
          _react2.default.createElement('path', {
            d: 'M2.625 0h7.615S12 0 12 2.292H4.41S4.425 0 2.625 0z',
            fill: '#F06361',
            className: 'jsx-3383499909'
          })
        ),
        _react2.default.createElement('path', {
          d: 'M45.998 42.778c.066 2.942-2.39 5.381-5.495 5.459H12.73a3.383 3.383 0 0 0-2.072.69c-.399-.472-.853-1.026-.853-2.718V11.477a4.586 4.586 0 0 1 1.408-3.364 5.115 5.115 0 0 1 3.508-1.429h25.782c3.115.077 5.575 2.531 5.495 5.482v30.612z',
          fill: '#D6D6D6',
          fillRule: 'nonzero',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M46.194 41.112c.08 2.95-2.38 5.405-5.495 5.482H14.917c-2.203 0-4.07.354-4.692 1.668-.162-.513-.224-1.397-.224-.984V9.804a4.585 4.585 0 0 1 1.403-3.37A5.115 5.115 0 0 1 14.917 5h25.782c3.115.077 5.575 2.531 5.495 5.482v30.63z',
          fill: '#BBB',
          fillRule: 'nonzero',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M48 37.754c-.091 2.992-2.807 5.352-6.072 5.275H13.757C10.58 43.03 8 44.43 8 47V10.277c0-2.913 2.577-5.275 5.757-5.275h28.17c3.266-.076 5.982 2.283 6.073 5.275v27.477z',
          fill: '#7878CB',
          fillRule: 'nonzero',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement(
          'g',
          { transform: 'translate(21.000000, 16.000000)', fill: '#FFF', className: 'jsx-3383499909'
          },
          _react2.default.createElement('path', { d: 'M7.494 16C3.424 16.06.074 12.545 0 8.137 0 6.958.884 6 1.974 6c1.09 0 1.974.957 1.974 2.138 0 2.124 1.59 3.846 3.552 3.846s3.552-1.722 3.552-3.846c0-1.18.884-2.138 1.974-2.138C14.116 6 15 6.957 15 8.138c-.073 4.408-3.424 7.922-7.494 7.861M13.003 4a2.018 2.018 0 0 1-1.418-.59A1.983 1.983 0 0 1 11 1.996a2.001 2.001 0 0 1 4 0c0 .534-.211 1.043-.585 1.412-.38.377-.885.588-1.412.591m-11 0a2.018 2.018 0 0 1-1.418-.591A1.985 1.985 0 0 1 0 1.996C0 1.463.211.953.585.584a2.006 2.006 0 0 1 2.83 0C3.789.953 4 1.463 4 1.996c0 .534-.211 1.044-.585 1.413-.38.377-.885.588-1.412.591', className: 'jsx-3383499909'
          })
        ),
        _react2.default.createElement('path', {
          d: 'M11.532 43.362C9.419 43.954 8 45.148 8 46.855V10.383c.005-1.889 1.348-3.635 3.532-4.59v37.57z',
          opacity: '0.2',
          fillRule: 'nonzero',
          fill: '#49497F',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M8.983 42a.339.339 0 0 1-.299-.177.285.285 0 0 1 .044-.322 4.94 4.94 0 0 1 1.064-.863.361.361 0 0 1 .36-.054c.121.049.2.157.201.278a.306.306 0 0 1-.194.281c-.342.21-.65.461-.915.75a.35.35 0 0 1-.26.107zm3.51-1.515c-.167-.021-.291-.15-.291-.304 0-.153.124-.283.29-.303.336 0 .672-.029 1.002-.029h.355c.166.021.29.15.29.304 0 .153-.124.283-.29.303H12.517l-.025.029zm28.066 0h-.08a.349.349 0 0 1-.33-.139.284.284 0 0 1 0-.33c.071-.1.2-.155.33-.138h.08c.392 0 .782-.043 1.163-.125a.33.33 0 0 1 .307.231.295.295 0 0 1-.151.336 6.285 6.285 0 0 1-1.319.142v.023zm-2.744 0h-1.331a.349.349 0 0 1-.329-.139.284.284 0 0 1 0-.33c.07-.1.199-.155.329-.138h1.331c.167.02.29.15.29.303s-.123.283-.29.304zm-4 0h-1.332a.349.349 0 0 1-.329-.139.284.284 0 0 1 0-.33c.07-.1.2-.155.329-.138h1.331c.167.02.29.15.29.303s-.123.283-.29.304zm-4.001 0h-1.325c-.167-.021-.29-.15-.29-.304 0-.153.123-.283.29-.303h1.331a.349.349 0 0 1 .329.138c.07.1.07.23 0 .33a.349.349 0 0 1-.329.139h-.006zm-4 0h-1.326c-.166-.021-.29-.15-.29-.304 0-.153.124-.283.29-.303h1.331c.167.02.29.15.29.303s-.123.283-.29.304h-.006zm-4.001 0h-1.326c-.166-.021-.29-.15-.29-.304 0-.153.124-.283.29-.303h1.332c.166.02.29.15.29.303s-.124.283-.29.304h-.006zm-4.001 0h-1.32a.349.349 0 0 1-.328-.139.284.284 0 0 1 0-.33c.07-.1.199-.155.329-.138h1.331c.167.02.29.15.29.303s-.123.283-.29.304h-.012zm26.312-1.254a.336.336 0 0 1-.305-.196.288.288 0 0 1 .081-.332c.314-.265.587-.569.809-.902a.359.359 0 0 1 .434-.065c.141.08.198.243.132.382-.25.369-.553.705-.902 1a.347.347 0 0 1-.243.09l-.006.023zm1.543-3.246c-.185 0-.336-.138-.336-.307v-1.237c.023-.152.165-.265.333-.265s.31.113.333.265v1.214c-.003.163-.145.295-.324.301l-.006.029zm0-3.65c-.185 0-.336-.137-.336-.306v-1.237a.297.297 0 0 1 .152-.3.363.363 0 0 1 .362 0c.11.065.17.182.152.3v1.214c0 .165-.143.3-.324.307l-.006.023zm0-3.648c-.185 0-.336-.138-.336-.307v-1.237a.297.297 0 0 1 .152-.3.363.363 0 0 1 .362 0c.11.065.17.182.152.3v1.214c0 .165-.143.3-.324.307l-.006.023zm0-3.65c-.185 0-.336-.137-.336-.306V23.5a.297.297 0 0 1 .152-.3.363.363 0 0 1 .362 0c.11.064.17.181.152.3v1.214c-.003.163-.145.295-.324.301l-.006.023zm0-3.648c-.185 0-.336-.137-.336-.307v-1.231a.297.297 0 0 1 .152-.3.363.363 0 0 1 .362 0c.11.064.17.181.152.3v1.214c-.016.154-.154.273-.324.278l-.006.046zm0-3.65c-.185 0-.336-.136-.336-.306v-1.231c.023-.152.165-.265.333-.265s.31.113.333.265v1.214c0 .165-.143.3-.324.307l-.006.017zm0-3.648c-.185 0-.336-.137-.336-.307V12.56c.023-.152.165-.265.333-.265s.31.113.333.265v1.214c-.003.163-.145.295-.324.3l-.006.018zM8 11.128l.087-.21a.35.35 0 0 1 .427-.15c.163.06.248.225.195.378-.158.369-.287.748-.385 1.135a.335.335 0 0 1-.324.21v-1.363zm37.331-.663a.337.337 0 0 1-.311-.193 3.973 3.973 0 0 0-.622-.976.289.289 0 0 1 .076-.41.36.36 0 0 1 .453.035c.292.346.528.728.703 1.135a.277.277 0 0 1-.001.235.318.318 0 0 1-.298.18v-.006zm-35.52-1.17a.337.337 0 0 1-.302-.188.286.286 0 0 1 .065-.328c.328-.307.693-.58 1.089-.811.1-.078.24-.095.358-.045s.195.158.195.277c.001.119-.074.227-.192.278a5.413 5.413 0 0 0-.977.721.345.345 0 0 1-.236.097zm32.776-1.322a.368.368 0 0 1-.124 0 5.361 5.361 0 0 0-1.201-.295c-.162-.041-.266-.186-.242-.338.024-.152.167-.265.335-.263.468.059.926.171 1.363.334a.297.297 0 0 1 .159.324.325.325 0 0 1-.283.244l-.007-.006zM13.345 7.69c-.171-.007-.31-.129-.322-.284-.013-.155.104-.294.272-.324.379-.052.761-.079 1.145-.08h.236a.349.349 0 0 1 .329.14c.07.1.07.229 0 .33a.349.349 0 0 1-.329.138h-.267c-.348 0-.696.025-1.04.074l-.024.006zm25.323-.074h-1.363c-.166-.021-.29-.15-.29-.304 0-.153.124-.283.29-.303h1.331a.349.349 0 0 1 .33.138c.07.1.07.23 0 .33a.349.349 0 0 1-.33.139h.032zm-4.001 0h-1.363a.349.349 0 0 1-.328-.139.284.284 0 0 1 0-.33c.07-.1.199-.155.328-.138h1.332c.166.02.29.15.29.303s-.124.283-.29.304h.03zm-4 0H29.31a.349.349 0 0 1-.329-.139.284.284 0 0 1 0-.33c.07-.1.2-.155.329-.138h1.331c.167.02.29.15.29.303s-.123.283-.29.304h.025zm-4.001-.006h-1.357a.349.349 0 0 1-.328-.138.284.284 0 0 1 0-.33c.07-.101.198-.155.328-.14h1.357a.349.349 0 0 1 .328.14c.07.1.07.229 0 .33a.349.349 0 0 1-.328.138zm-4.001 0h-1.356a.349.349 0 0 1-.33-.138.284.284 0 0 1 0-.33c.071-.101.2-.155.33-.14h1.331a.349.349 0 0 1 .329.14c.07.1.07.229 0 .33a.349.349 0 0 1-.329.138h.025zm-4 0h-1.332c-.167-.02-.29-.15-.29-.304 0-.153.123-.282.29-.303h1.331a.349.349 0 0 1 .329.138c.07.101.07.23 0 .33a.349.349 0 0 1-.329.14z',
          fill: '#49497F',
          fillRule: 'nonzero',
          opacity: '0.5',
          className: 'jsx-3383499909'
        })
      )
    ),
    _react2.default.createElement(
      _style2.default,
      {
        id: '3383499909'
      },
      ['.green.jsx-3383499909{fill:#00b083;}', '.purple.jsx-3383499909{fill:#7878cb;}', '.gray.jsx-3383499909{fill:#767c7c;}', '.holder.jsx-3383499909{position:relative;display:inline-block;}', '.icon.jsx-3383499909{position:absolute;bottom:-10%;right:-5%;z-index:2;}']
    )
  );
}

Book.propTypes = {
  size: _propTypes2.default.number,
  icon: _propTypes2.default.node
};

exports.default = Book;